<template>
	<div class="contact" v-html="about">
	</div>
</template>
<script>
	export default {
		name: 'Contact',
		props: {
			about: String
		}
	}
</script>
<style lang="scss">
	p+p {
		margin-top:1rem;
		
	}
	p {
		max-width: 37rem;;
		&.mail {
			margin-top:3rem;
		}
	}
	h2 {
		margin-bottom:3rem;
	}
</style>